import { createReducer } from '@reduxjs/toolkit';

import { addTierAction, changePlan, deleteTier, deleteUser, exportUsers, getDashboardData, getTiers, getTiersList, getUsersList, updateTierAction, userProfileAction, userProfileSwitch } from './actions';
import { removeDuplicateRecords } from '../../../utility/helpers';
import { NUMBERS } from '../../../resources/number-constants';

const initialState: any = {
  data: null,
  adminUsers: {
    results: [],
    currentPage: 0,
    total: 1,
    totalEntries: 0,
    responseStatus: true,
    usersCount: null,
    current: 0,
    lastPage: 0,
    next: null,
    previous: null
  },
  adminTiers: {
    results: [],
    currentPage: 0,
    total: 1,
    totalEntries: 0,
    responseStatus: true,
    tiersCount: null,
  }
};

const adminReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getUsersList.fulfilled, (state, { payload }) => {
      const { queryParams, total, data, responseStatus, usersCount, current, lastPage, next, previous }: any = payload;
      state.adminUsers.results = data;
      state.adminUsers.results = removeDuplicateRecords(state.adminUsers.results);
      state.adminUsers.total = Math.ceil(usersCount / NUMBERS.SEVEN);
      state.adminUsers.currentPage = queryParams.page;
      state.adminUsers.totalEntries = total;
      state.adminUsers.responseStatus = responseStatus;
      state.adminUsers.usersCount = usersCount;
      state.adminUsers.current = current;
      state.adminUsers.lastPage = lastPage;
      state.adminUsers.next = next;
      state.adminUsers.previous = previous;
    })
    .addCase(getTiers.fulfilled, (state, { payload }) => {
      state.data = payload?.data;
    })
    .addCase(userProfileAction.fulfilled, (state, { payload }) => {
      state.data = payload?.data;
    })
    .addCase(addTierAction.fulfilled, (state, { payload }) => {
      state.data = payload?.data;
    })
    .addCase(updateTierAction.fulfilled, (state, { payload }) => {
      state.data = payload?.data;
    })
    .addCase(getTiersList.fulfilled, (state, { payload }) => {
      const { queryParams, total, data, responseStatus, tiersCount }: any = payload;

      if  (queryParams.page === NUMBERS.ONE) {
            state.adminTiers.results = data;
      } else  {
          state.adminTiers.results = [
              ...state.adminTiers.results,
              ...data,
          ];
      }
      state.adminTiers.results = removeDuplicateRecords(state.adminTiers.results);
      state.adminTiers.total = Math.ceil(tiersCount / NUMBERS.TEN);
      state.adminTiers.currentPage = queryParams.page;
      state.adminTiers.totalEntries = total;
      state.adminTiers.responseStatus = responseStatus;
      state.adminTiers.tiersCount = tiersCount;
    })
    .addCase(deleteTier.fulfilled, (state, { payload }) => {
      state.data = payload?.data;
    })
    .addCase(exportUsers.fulfilled, (state, { payload }) => {
      state.data = payload;
    })
    .addCase(userProfileSwitch.fulfilled, (state, { payload }) => {
      state.data = payload;
    })
    .addCase(changePlan.fulfilled, (state, { payload }) => {
      state.data = payload?.data;
    })
    .addCase(getDashboardData.fulfilled, (state, { payload }) => {
      state.data = payload?.data;
    })
    .addCase(deleteUser.fulfilled, (state, { payload }) => {
      state.data = payload?.data;
    });
});

export default adminReducer;
